module.exports = __webpack_public_path__ + "img/title-logo.58c6efbd.png";